import { render, staticRenderFns } from "./ListDpaAccountPage.vue?vue&type=template&id=31fec80e&"
import script from "./ListDpaAccountPage.vue?vue&type=script&lang=js&"
export * from "./ListDpaAccountPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports